import { ProjectAPI } from '@brg/api';
import { useAPIMethodArray } from '../useAPIMethodArray';
import { useAPIMethod } from '../useAPIMethod';
export var useProjectsByFilter = function (request, lang, t) {
    if (lang === void 0) { lang = 'en'; }
    return useAPIMethodArray(ProjectAPI.GetProjectsByFilter, request, lang, t);
};
export var useProjectsList = function (request, lang, t, disabled) {
    if (lang === void 0) { lang = 'en'; }
    return useAPIMethod(ProjectAPI.GetList, request, lang, t, disabled);
};
export var useTagsProjects = function (request, lang, t) {
    if (lang === void 0) { lang = 'en'; }
    return useAPIMethodArray(ProjectAPI.GetTagsProjects, request, lang, t);
};
//# sourceMappingURL=useProjectsByFilter.js.mapimport { ProjectAPI } from '@brg/api';
import { useAPIMethodArray } from '../useAPIMethodArray';
import { useAPIMethod } from '../useAPIMethod';
export var useProjectsByFilter = function (request, lang, t) {
    if (lang === void 0) { lang = 'en'; }
    return useAPIMethodArray(ProjectAPI.GetProjectsByFilter, request, lang, t);
};
export var useProjectsList = function (request, lang, t, disabled) {
    if (lang === void 0) { lang = 'en'; }
    return useAPIMethod(ProjectAPI.GetList, request, lang, t, disabled);
};
export var useTagsProjects = function (request, lang, t) {
    if (lang === void 0) { lang = 'en'; }
    return useAPIMethodArray(ProjectAPI.GetTagsProjects, request, lang, t);
};
//# sourceMappingURL=useProjectsByFilter.js.map